import React, { useEffect } from 'react';
import { CheckCircle, XCircle, Info, X } from 'lucide-react';
type ToastType = 'success' | 'error' | 'info';
interface ToastProps {
  message: string;
  type: ToastType;
  onClose: () => void;
}
export function Toast({
  message,
  type,
  onClose
}: ToastProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);
  const icons = {
    success: <CheckCircle className="h-5 w-5 text-green-500" data-id="element-1839" />,
    error: <XCircle className="h-5 w-5 text-red-500" data-id="element-1840" />,
    info: <Info className="h-5 w-5 text-blue-500" data-id="element-1841" />
  };
  const bgColors = {
    success: 'bg-green-50 border-green-200',
    error: 'bg-red-50 border-red-200',
    info: 'bg-blue-50 border-blue-200'
  };
  return <div className="fixed top-4 right-4 z-50 animate-in slide-in-from-top-2" data-id="element-1842">
      <div className={`flex items-center gap-3 px-4 py-3 rounded-lg border shadow-lg ${bgColors[type]} min-w-[300px]`} data-id="element-1843">
        {icons[type]}
        <p className="flex-1 text-sm font-medium text-gray-900" data-id="element-1844">{message}</p>
        <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-1845">
          <X className="h-4 w-4" data-id="element-1846" />
        </button>
      </div>
    </div>;
}